import { render, staticRenderFns } from "./DashboardReport.vue?vue&type=template&id=50b49c8c&scoped=true&"
import script from "./DashboardReport.vue?vue&type=script&lang=js&"
export * from "./DashboardReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b49c8c",
  null
  
)

export default component.exports